import React, { useState, useEffect } from 'react';
import { Formik, Form } from 'formik';
import { useHistory } from 'react-router';
import * as Yup from 'yup';
import Box from '@material-ui/core/Box';
import { LOGOUT } from 'ConstComponents';
import {
    VerifyOTP as SENDER_VERIFY,
    ResendOTP as SENDER_RESEND_OTP
} from 'Components/Api/SenderAPI';

import { MaterialTextField } from 'Components/Inputes/FormikMaterialInput';
import { MaterialNumberField } from 'Components/Inputes/FormikMaterialNumberInput';
import { useLocation } from 'react-router-dom';
import { Container, Grid, Paper, Button } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import { commonStyle } from 'Components/CustomMaterialStyleSheets/CommonStyleSheet';
import { PLEASE_PROVIDE_VALID } from 'Components/Helper/Messages';

import HOCLoader from 'Components/Loader/HOCLoader';
const CustomContainer = HOCLoader(Container);

export const SenderVerify = () => {
    const classes = commonStyle();
    const history = useHistory();
    const location = useLocation();
    const [responseMessage, setResponseMessage] = useState('');
    const [isError, setIsError] = useState(false);
    const [loading, setLoading] = useState(false);
    const [severity, setSeverity] = useState('success');
    const Mobile = location.state.Mobile;
    const [formObject, setFormObject] = useState({
        Mobile: Mobile,
        OTP: ''
    });
    const resendOTP = async (values) => {
        var requestObj = JSON.stringify(values);
        setLoading(true);
        setIsError(false);
        var response = await SENDER_RESEND_OTP(requestObj);
        if (!response.isAuthorized) LOGOUT();

        setLoading(false);
        setIsError(true);
        setSeverity('success');
        setResponseMessage(response.data);
        if (!response.status) {
            setSeverity('error');
            return;
        }
    };
    const submithandle = async (values, { setSubmitting, resetForm }) => {
        var requestObj = JSON.stringify(values);

        setLoading(true);
        setIsError(false);

        var response = await SENDER_VERIFY(requestObj);
        if (!response.isAuthorized) LOGOUT();

        setIsError(true);

        setSeverity('success');
        setResponseMessage(response.data);

        if (!response.status) {
            setLoading(false);
            setSeverity('error');
            return;
        }
        resetForm(formObject);
        var param = {
            Mobile: values.Mobile
        };

        history.push('/IC_SenderSearch', param);
    };

    const select = () => {
        setLoading(true);
        let primaryID = Mobile;

        setLoading(false);

        setFormObject({
            ...formObject,
            Mobile: primaryID,
            OTP: ''
        });
    };
    useEffect(() => {
        select();
    }, []);

    const FormValidationSchema = Yup.object({
        Mobile: Yup.string().required(PLEASE_PROVIDE_VALID + 'mobile'),
        OTP: Yup.string().required(PLEASE_PROVIDE_VALID + 'otp')
    });

    return (
        <CustomContainer
            isLoading={loading}
            isError={isError}
            alertMessage={responseMessage}
            severity={severity}
            onCloseCallback={(alertState) => {
                setIsError(alertState);
            }}
        >
            <Formik
                enableReinitialize={true}
                initialValues={formObject}
                validationSchema={FormValidationSchema}
                onSubmit={submithandle}
                resetForm={formObject}
                render={({ values, setFieldValue, handleSubmit }) => {
                    return (
                        <Form>
                            <h2 className={classes.PaperHead_h2}>
                                Sender Verify
                            </h2>
                            <Grid item xs={12}>
                                <Paper className={classes.PaperStyle}>
                                    <Grid container spacing={2}>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={6}
                                            lg={6}
                                        >
                                            <MaterialNumberField
                                                label="Mobile"
                                                name="Mobile"
                                                type="Mobile"
                                                length={10}
                                                readOnly={true}
                                                placeholder="Mobile"
                                            />
                                        </Grid>
                                        <Grid
                                            item
                                            xs={12}
                                            sm={12}
                                            md={6}
                                            lg={6}
                                        >
                                            <MaterialTextField
                                                label="OTP"
                                                name="OTP"
                                                type="text"
                                                length={6}
                                                placeholder="OTP"
                                            />
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>

                            <Grid className={classes.footerGrid}>
                                <Box className={classes.flexReverse}>
                                    <div className={classes.SubmitWrapper}>
                                        <Button
                                            type="submit"
                                            title="Verify"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            onClick={(e) => {
                                                setFieldValue(
                                                    'isSecondSubmit',
                                                    false
                                                );
                                                handleSubmit(e);
                                            }}
                                            disabled={loading}
                                        >
                                            Verify
                                        </Button>
                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>

                                    <div
                                        className={
                                            classes.SubmitWrapperWithMarginRight
                                        }
                                    >
                                        <Button
                                            title="Resend"
                                            className={
                                                classes.CustomPrimaryButtonStyle
                                            }
                                            disabled={loading}
                                            fullWidth
                                            onClick={(e) => {
                                                resendOTP(values);
                                            }}
                                        >
                                            Resend
                                        </Button>
                                        {loading && (
                                            <CircularProgress
                                                size={24}
                                                className={
                                                    classes.buttonProgress
                                                }
                                            />
                                        )}
                                    </div>
                                    <Button
                                        type="reset"
                                        title="Reset"
                                        className={
                                            classes.CustomDangerButtonStyle
                                        }
                                    >
                                        Reset
                                    </Button>
                                </Box>
                            </Grid>
                        </Form>
                    );
                }}
            />
        </CustomContainer>
    );
};
